var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'STANDARD')?_c('v-icon',[_vm._v("collections")]):(_vm.type === 'VIDEO')?_c('v-icon',[_vm._v("video_library")]):(_vm.type === 'INSPECTION')?_c('v-icon',[_vm._v("search")]):(_vm.type === 'INSPECTION_REPAIR_ORDER')?_c('v-icon',[_vm._v("build")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }